import { TableCell } from "./TableCell";

export class CompactTableCell extends TableCell {
    private _order: number = 0;

    public get order(): number {
        return this._order;
    }

    public set order(v: number) {
        this._order = v;

        if (this.element) {
            this.element.style.order = this._order.toString();
        }
    }

    public override toEdit(v: boolean): void {
        super.toEdit(v);
        this.element.classList.add("CompactTableCell");
        this.element.removeAttribute("width");
        this.element.style.order = this._order.toString();
    }
}
